import { getStoredAuth } from './authStorage';

interface UploadActivity {
    refreshToken: string;
    inFlightCount: number;
    lastUploadEndedAt: number | null;
}

let activity: UploadActivity | undefined;

function currentActivity(): UploadActivity {
    const refreshToken = getStoredAuth()?.refreshToken ?? '';
    if (!activity || activity.refreshToken !== refreshToken) {
        activity = { refreshToken, inFlightCount: 0, lastUploadEndedAt: null };
    }
    return activity;
}

export async function trackUpload<T>(run: () => Promise<T>, refreshToken = getStoredAuth()?.refreshToken ?? ''): Promise<T> {
    const scope = currentActivity();
    const isCurrent = scope.refreshToken === refreshToken;
    if (isCurrent) scope.inFlightCount += 1;
    try {
        return await run();
    } finally {
        if (isCurrent) {
            scope.inFlightCount = Math.max(0, scope.inFlightCount - 1);
            scope.lastUploadEndedAt = Date.now();
        }
    }
}

export function getLastUploadActivityAt(): number | null {
    const scope = currentActivity();
    return scope.inFlightCount > 0 ? Date.now() : scope.lastUploadEndedAt;
}

export function resetUploadActivity(): void {
    activity = undefined;
}
